export const pontoType = [
  {
    name: 'FALTA JUSTIFICADA',
    value: 'falta_just'
  },
  {
    name: 'FALTA ABONADA',
    value: 'falta_abo'
  },
  {
    name: 'ATESTADO DE HORAS',
    value: 'ates_horas'
  },
  {
    name: 'FOLGA DE ANIVERSÁRIO',
    value: 'aniver'
  },
  {
    name: 'ATESTADO MÉDICO',
    value: 'atest_medic'
  },
  {
    name: 'FOLGA DE ELEIÇÃO',
    value: 'eleicao'
  },
  {
    name: 'ATESTADO DE ACOMPANHAMENTO MÉDICO',
    value: 'acomp'
  },
  {
    name: 'BANCO DE HORAS',
    value: 'b_horas'
  }
]